<template>
  <div id="search">
    <core-header
        :search-page="true"
    />
    <video-filter
        :auto-filter="false"/>
    <video-list
        :header-has-more="false"
        header-title="搜索结果"
        :first-is-enlarge="false"
        :hot-video="false"
    />
  </div>
</template>

<script>
export default {
  name: 'Search',

  components: {
    CoreHeader: () => import('@/components/core/Header'),
    VideoFilter: () => import('@/components/video/VideoFilter'),
    VideoList: () => import('@/components/video/VideoList'),
  },
}
</script>
